import type { RouteAccessInput, RouteRole } from './types'
import { HOME_BY_ROLE } from './route-registry'
import type { UserRole } from '@/types/account'
import type { ActualRole } from '@/types/qa-perspective'
import { isAdminRole } from '@/lib/account/account-roles'

export function mapUserRoleToRouteRole(role?: UserRole | null): RouteRole {
  if (!role || role === 'individual') return 'individual'
  if (role === 'admin') return 'admin'
  if (role === 'organization_owner') return 'organization_owner'
  if (role === 'organization_member') return 'organization_member'
  return 'individual'
}

export function mapActualRoleToRouteRole(role: ActualRole): RouteRole {
  return role
}

export function isActualAdminRole(role?: UserRole | null): boolean {
  return isAdminRole(role)
}

export function canAccessRoute(input: RouteAccessInput): boolean {
  const { route, actualRole, effectiveRole, activeContextScope, isAnonymous } = input

  if (route.publicAccess) {
    return true
  }

  if (route.requiresKnownUser && isAnonymous) {
    return false
  }

  const isActualAdmin = actualRole === 'admin'

  if (route.adminActualOnly) {
    return isActualAdmin
  }

  if (route.adminBypass && isActualAdmin) {
    return true
  }

  const roleToCheck = effectiveRole
  if (!route.allowedRoles.includes(roleToCheck)) {
    return false
  }

  if (route.requiredContext && activeContextScope !== route.requiredContext) {
    return false
  }

  return true
}

export function getAccessDeniedRedirect(
  effectiveRole: RouteRole,
  fallback = HOME_BY_ROLE.individual,
): string {
  return HOME_BY_ROLE[effectiveRole] ?? fallback
}
